import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { AddToCartTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/addToCart.trackingInfo";
import { RemoveFromCartTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/removeFromCart.trackingInfo";
import { ProductImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/productImpression.trackingInfo";
import { ModelMapper } from "@omni/types/utils/modelMapper";

import { TrackingProductModel } from "@/services/tracking/types/trackingProduct.model";

export const toProductImpression: ModelMapper<
    Product<ProductFieldSet.ProductTile>,
    ProductImpressionTrackingInfo
> = (product) => {
    const roundedDiscountPercentage = product.price?.discountPercentage
        ? Math.floor(product.price.discountPercentage)
        : 0;

    return {
        id: product.sku,
        ean: product.ean,
        name: product.analytics.productTitle || product.title,
        category:
            product.analytics.superCategoryCode || product.superCategoryName,
        price: product.price?.currentPrice || 0,
        unitPrice: product.price?.currentConversionPrice || 0,
        tax: "21%",
        reduction: `${roundedDiscountPercentage}%`,
        currencyCode: "EUR",
        brand: product.brand?.name ?? "",
        reviewCount: product.statistics?.totalReviewCount,
        reviewAverage: product.statistics?.averageOverallRating
    };
};

export const toTrackingProduct: ModelMapper<
    Product<ProductFieldSet.ProductTile>,
    TrackingProductModel
> = (product) => {
    const roundedDiscountPercentage = product.price?.discountPercentage
        ? Math.floor(product.price.discountPercentage)
        : 0;

    return {
        id: product.sku,
        ean: product.ean,
        name: product.analytics?.productTitle || product.title,
        category: product.analytics?.superCategoryCode || product.brand?.code,
        price: product.price?.currentPrice || 0,
        unitPrice: product.price?.currentConversionPrice || 0,
        tax: "21%",
        reduction: `${roundedDiscountPercentage}%`,
        currencyCode: "EUR",
        brand: product.brand?.name ?? "",
        reviewCount: product.statistics?.totalReviewCount,
        reviewAverage: product.statistics?.averageOverallRating
    };
};

export const toAddToCartTrackingInfo: ModelMapper<
    { product: Product<ProductFieldSet.ProductTile>; quantity: number },
    AddToCartTrackingInfo
> = ({ product, quantity }) => {
    const roundedDiscountPercentage = product.price?.discountPercentage
        ? Math.floor(product.price.discountPercentage)
        : 0;

    return {
        id: product.sku,
        ean: product.ean,
        name: product.analytics.productTitle || product.title,
        category:
            product.analytics.superCategoryCode || product.superCategoryName,
        price: product.price?.currentPrice || 0,
        unitPrice: product.price?.currentConversionPrice || 0,
        tax: "21%",
        reduction: `${roundedDiscountPercentage}%`,
        currencyCode: "EUR",
        brand: product.brand?.name ?? "",
        reviewCount: product.statistics?.totalReviewCount,
        reviewAverage: product.statistics?.averageOverallRating,
        quantity: quantity,
        url: product.url
    };
};

export const toRemoveFromCartTrackingInfo: ModelMapper<
    { product: Product<ProductFieldSet.ProductTile>; quantity: number },
    RemoveFromCartTrackingInfo
> = ({ product, quantity }) => {
    const roundedDiscountPercentage = product.price?.discountPercentage
        ? Math.floor(product.price.discountPercentage)
        : 0;

    return {
        id: product.sku,
        ean: product.ean,
        name: product.analytics.productTitle || product.title,
        category:
            product.analytics.superCategoryCode || product.superCategoryName,
        price: product.price?.currentPrice || 0,
        unitPrice: product.price?.currentConversionPrice || 0,
        tax: "21%",
        reduction: `${roundedDiscountPercentage}%`,
        currencyCode: "EUR",
        brand: product.brand?.name ?? "",
        reviewCount: product.statistics?.totalReviewCount,
        reviewAverage: product.statistics?.averageOverallRating,
        quantity: quantity,
        url: product.url
    };
};
